import type { SkeletonShape } from './types'

/** Радиус по умолчанию для формы, если явно не задан пропом radius. */
export const SKELETON_DEFAULT_RADIUS: Record<SkeletonShape, number> = {
  TEXT: 6,
  RECT: 16,
  CIRCLE: 0,
}

export const SKELETON_DEFAULT_HEIGHT = 14

/** Ширина последней строки текстового скелетона — короче остальных, как в макете. */
export const SKELETON_LAST_LINE_WIDTH = '64%'
